import React from 'react';
import { Box, Typography } from '@mui/material';

const formatCurrency = (v) =>
    new Intl.NumberFormat('fr-BE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(v || 0);

const VatByQuarter = ({ quarters, year }) => {
    if (!quarters || quarters.length === 0) return null;

    const today = new Date();
    const currentYear = today.getFullYear();
    const currentQuarter = Math.floor(today.getMonth() / 3) + 1;
    const total = quarters.reduce((sum, q) => sum + (q.vat || 0), 0);

    // Returns 'current', 'closed' or 'upcoming' for a quarter of the selected year
    const getState = (quarter) => {
        if (year < currentYear) return 'closed';
        if (year > currentYear) return 'upcoming';
        if (quarter === currentQuarter) return 'current';
        return quarter < currentQuarter ? 'closed' : 'upcoming';
    };

    const stateLabels = { current: 'en cours', closed: 'clôturé', upcoming: 'à venir' };

    return (
        <Box sx={{ mb: 4 }}>
            <Box display="flex" alignItems="baseline" flexWrap="wrap" gap={1} mb={2}>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    TVA à payer par trimestre
                </Typography>
                <Box flexGrow={1} />
                <Typography variant="body2" color="text.secondary">
                    Total {year} :
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                    {formatCurrency(total)}
                </Typography>
            </Box>
            <Box display="flex" flexWrap="wrap" gap={2}>
                {quarters.map((q) => {
                    const state = getState(q.quarter);
                    const isCurrent = state === 'current';
                    return (
                        <Box
                            key={q.quarter}
                            sx={{
                                flex: 1,
                                minWidth: 160,
                                p: 2,
                                border: isCurrent ? '2px solid' : '1px solid',
                                borderColor: isCurrent ? 'primary.main' : 'divider',
                                borderRadius: 1,
                                opacity: state === 'upcoming' ? 0.6 : 1,
                            }}
                        >
                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                    T{q.quarter}
                                </Typography>
                                <Typography variant="caption" color={isCurrent ? 'primary.main' : 'text.secondary'}>
                                    {stateLabels[state]}
                                </Typography>
                            </Box>
                            <Typography variant="h5" sx={{ fontWeight: 700 }}>
                                {formatCurrency(q.vat)}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                {formatCurrency(q.revenue_untaxed)} HT · {q.invoice_count} facture{q.invoice_count > 1 ? 's' : ''}
                            </Typography>
                        </Box>
                    );
                })}
            </Box>
            <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
                TVA collectée sur les factures envoyées, notes de crédit déduites (hors TVA déductible sur achats).
            </Typography>
        </Box>
    );
};

export default VatByQuarter;
